import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
    // Team member data
    const teamMembers = [
        { order: 1, name: "Brett B.", imageFile: "BrettB.JPEG" },
        { order: 2, name: "Dr. Reginald", imageFile: "DrReginald.JPEG" },
        { order: 3, name: "David S.", imageFile: "DavidS.JPEG" },
        { order: 4, name: "Tom Luca", imageFile: "TomLuca.JPEG" },
        { order: 5, name: "Amrat C.", imageFile: "AmratC.JPEG" },
        { order: 6, name: "Morena D.", imageFile: "MorenaD.JPEG" },
        { order: 7, name: "Ryan H.", imageFile: "RyanH.JPEG" },
        { order: 8, name: "Fabricia A.", imageFile: "FabriciaA.JPEG" },
        { order: 9, name: "Jacob R.", imageFile: "JacobR.JPEG" },
        { order: 10, name: "Kyathi U.", imageFile: "KyathiU.JPEG" },
        { order: 11, name: "Haylee R.", imageFile: "HayleeR.JPEG" },
        { order: 12, name: "Shaniya M.", imageFile: "ShaniyaM.JPEG" },
        { order: 13, name: "Valarie W.", imageFile: "ValarieW.JPEG" },
        { order: 14, name: "Jordan D.", imageFile: "JordanD.JPEG" },
        { order: 15, name: "Emmanuel P.", imageFile: "EmmanuelP.JPEG" }
    ];

    // News articles data
    const newsArticles = [
        {
            id: 1,
            title: "CEO Explains How PilotHelper Can Support Aviation Workers",
            source: "WBAL-TV",
            url: "https://www.wbaltv.com/article/ceo-explains-how-pilothelper-can-support-aviation-workers/69229147"
        },
        {
            id: 2,
            title: "PilotHelper Expands Mental Health Support for Pilots in Arkansas",
            source: "KATV",
            url: "https://katv.com/community/little-rock-arc/pilot-helper-expands-mental-health-support-for-pilots-in-arkansas-peer-support-flying-experience-crisis-diagnosed-flight-schools-course-family-friends"
        },
        {
            id: 3,
            title: "PilotHelper Alabama Brings Mental Health Support",
            source: "WBRC",
            url: "https://www.wbrc.com/video/2025/11/24/pilothelper-alabama-brings-mental-health-support/"
        },
        {
            id: 4,
            title: "Organization Strengthens Mental Wellness in Aviation",
            source: "WESH",
            url: "https://www.wesh.com/article/organization-strengthens-mental-wellness-in-aviation/69853166"
        }
    ];

    return (
        <div className="about-us-container">
            {/* Section 1: Hero Section */}
            <section className="about-hero">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h1 className="display-4 fw-bold mb-4">About PilotHelper</h1>
                            <p className="lead">
                                PilotHelper provides aviation-specific peer support training for airlines,
                                aviation colleges, and flight schools. Our programs train pilots and aviation
                                professionals to recognize when someone in their community may need support and
                                how to respond effectively.  <br /> <br/>  Unlike traditional models that rely only on designated
                                mentors, PilotHelper trains the people pilots already trust—their fellow pilots,
                                classmates, instructors, and even family members. This trust-based model helps
                                strengthen safety culture, communication, early intervention, and pilot retention
                                across the aviation community.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/collage.png`}
                                alt="PilotHelper users collage"
                                className="img-fluid collage-image"
                                loading="lazy"
                                onError={(e) => {
                                    e.target.src = `${process.env.PUBLIC_URL}/assets/collage.PNG`;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: In the News */}
            <section className="news-section bg-light">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="section-title display-5 fw-bold mb-3">In the News</h2>
                        <p className="lead text-muted">
                            News coverage highlighting PilotHelper's role in advancing aviation safety
                        </p>
                    </div>

                    <div className="news-grid">
                        {newsArticles.map((article) => (
                            <a
                                key={article.id}
                                href={article.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="news-card"
                            >
                                <div className="news-card-content">
                                    <div className="news-source">{article.source}</div>
                                    <h3 className="news-title">{article.title}</h3>
                                    <div className="news-link">Watch Video→</div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* Section 3: Our Team */}
            <section className="team-section">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="section-title display-5 fw-bold mb-3">Our Team</h2>
                        <p className="lead text-muted">
                            We are a diverse group of pilots, doctors, and aviation professionals.
                        </p>
                    </div>

                    <div className="team-scroll-container">
                        <div className="team-cards-wrapper">
                            {teamMembers.map((member) => (
                                <div key={member.order} className="team-card">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/${member.imageFile}`}
                                        alt={member.name}
                                        className="team-card-image"
                                        loading="lazy"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="cta-section bg-dark text-white text-center">
                <div className="container py-5">
                    <h2 className="mb-4">Ready to make a difference?</h2>
                    <p className="lead mb-4">Join our community of aviation professionals committed to supporting each other.</p>
                    <Link to="/contact" className="btn btn-light btn-lg">Contact Us</Link>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;